export default function InConstructionPage(){
    return(
        <div>
            <h1>Pagina en construcción</h1>
            <h3>Estamos trabajando</h3>
        </div>
    )
}